import { useTranslation } from 'react-i18next';

interface FeeBreakdown {
  hasBreakdown: boolean;
  baseFee: number;
  gratuity: number;
  gratuityPercent: number;
  menuTax: number;
  salesTax: number;
  salesTaxPercent: number;
  serviceFee: number;
  serviceFeePercent: number;
  pairingsFee: number;
  total: number;
}

interface FeeBreakdownDisplayProps {
  feeBreakdown: FeeBreakdown;
  displayCurrency: string;
}

export function FeeBreakdownDisplay({ feeBreakdown, displayCurrency }: FeeBreakdownDisplayProps) {
  const { t } = useTranslation('booking');
  const feeAmount = feeBreakdown.total;

  return (
    <div className="space-y-2">
      {feeBreakdown.hasBreakdown && (
        <>
          <div className="flex justify-between items-center text-sm text-foreground/70">
            <p>{t('NEW_MODAL_SUBTOTAL')}</p>
            <p>{displayCurrency} {feeBreakdown.baseFee.toLocaleString()}</p>
          </div>
          {feeBreakdown.gratuity > 0 && (
            <div className="flex justify-between items-center text-sm text-foreground/70">
              <p>{t('NEW_MODAL_SERVICE_GRATUITY', { percent: feeBreakdown.gratuityPercent })}</p>
              <p>{displayCurrency} {feeBreakdown.gratuity.toLocaleString()}</p>
            </div>
          )}
          {feeBreakdown.menuTax > 0 && (
            <div className="flex justify-between items-center text-sm text-foreground/70">
              <p>{t('NEW_MODAL_TAX')}</p>
              <p>{displayCurrency} {feeBreakdown.menuTax.toLocaleString()}</p>
            </div>
          )}
          {feeBreakdown.salesTax > 0 && (
            <div className="flex justify-between items-center text-sm text-foreground/70">
              <p>{t('PAYMENT_SALES_TAX', { percent: feeBreakdown.salesTaxPercent })}</p>
              <p>{displayCurrency} {feeBreakdown.salesTax.toLocaleString()}</p>
            </div>
          )}
          {feeBreakdown.serviceFee > 0 && (
            <div className="flex justify-between items-center text-sm text-foreground/70">
              <p>{t('SERVICE_FEE', { percent: feeBreakdown.serviceFeePercent })}</p>
              <p>{displayCurrency} {feeBreakdown.serviceFee.toLocaleString()}</p>
            </div>
          )}
          {feeBreakdown.pairingsFee > 0 && (
            <div className="flex justify-between items-center text-sm text-foreground/70">
              <p>{t('PAYMENT_PAIRINGS_FEE')}</p>
              <p>{displayCurrency} {feeBreakdown.pairingsFee.toLocaleString()}</p>
            </div>
          )}
        </>
      )}
      <div className="flex justify-between items-center border-b border-border pb-3">
        <p className="text-lg font-medium">{t('NEW_MODAL_TOTAL')}</p>
        <p className="text-lg font-medium">
          {displayCurrency} {feeAmount.toLocaleString()}
        </p>
      </div>
    </div>
  );
}
